class NotesController {
  constructor(addPromiseService, authService, contactService) {
    "ngInject";

    this.addPromiseService = addPromiseService;
    this.authService = authService;
    this.contactService = contactService;
  }

  addNote() {
    if (this.tempNote) {
      const newNote = {
        text: this.tempNote,
        date: 'Now',
        timeStamp: new Date()
      };

      this.notesCollection = [newNote, ...this.notesCollection];

      /*
      * There was a contact id passed in arguments to this NotesController
      * which means that this should be saved to the contact instantly
      */
      if (this.contactId) {
        this.contactService.addNote(this.authService.authData.currentLocation.key, this.contactId, this.tempNote);
      }

      this.tempNote = '';
    }
  }

  addNoteWithPromise() {
    if (this.tempNote) {
      this.addPromiseService.showAddPromise(this.addPromise.bind(this), true, this.tempNote, this.contact, true);
    }
  }

  addPromise(promise) {
    const ctrl = this;

    const newNote = {
      text: this.tempNote,
      date: 'Now',
      timeStamp: new Date(),
      promise: promise
    };

    this.notesCollection = [newNote, ...this.notesCollection];

    this.tempNote = '';
  }
}

export default NotesController;



// WEBPACK FOOTER //
// ./client/app/components/common/notes/notes.controller.js